"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const DefaultIcon_1 = tslib_1.__importDefault(require("./DefaultIcon"));
exports.default = (props) => (React.createElement(DefaultIcon_1.default, Object.assign({}, props, { viewBox: "0 96 960 960" }),
    React.createElement("path", { d: "M272 856V296h221q65 0 120 40t55 111q0 51-23 78.5T602 565q25 11 55.5 41t30.5 90q0 89-65 124.5T501 856H272Zm121-112h104q48 0 58.5-24.5T566 684q0-11-10.5-35.5T494 624H393v120Zm0-228h93q33 0 48-17t15-38q0-24-17-39t-44-15h-95v109Z" })));
